export default {
  delete: ({ DELETE }, idUser) =>
    new Promise((resolve, reject) => {
      if (!idUser) {
        reject(new Error(`Erreur paramètre : idUser non valide "${idUser}"`))
      }
      return DELETE(`users/${idUser}`)
        .then(reponse => {
          const data = reponse.data
          if ([200, 204].includes(reponse.status)) {
            resolve(data)
          } else {
            reject(reponse.status)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
}
